module.exports = __webpack_public_path__ + "img/3.241e5104.png";